import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=65cf3a33&scoped=true&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=65cf3a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf3a33",
  null
  
)

export default component.exports